import styled from 'styled-components';

const PlaylistScreen = () => {
  return (
    <Wrapper>
      <h2>PlaylistScreen</h2>
    </Wrapper>
  );
};

const Wrapper = styled.main`
  padding: 5px 5px;
`;

export default PlaylistScreen;
